export default "__VITE_ASSET__Dr4q99FM__"